import { apiService } from "../api.service";
export const passwordResetRequest = async (email: string) => {
  return apiService.apiRequest<any>("post", `auth/request-password-reset`, {
    email,
  });
};
